<template>
  <div class="leasecontract">
    <el-tabs v-model="allActiveName" @tab-click="handleTab">
      <el-tab-pane
        v-for="(item, index) in allTabList"
        :key="'tabList' + index"
        :label="returnPaneLabel(item.name, item.value, item)"
        :name="item.state + ''"
      >
        <!-- 退车核算 -->
        <el-tabs
          v-if="allActiveName === '3'"
          type="card"
          v-model="accountingActiveName"
          @tab-click="handleTab"
        >
          <el-tab-pane
            v-for="(item, index) in accountingTabList"
            :key="'tabList' + index"
            :label="returnPaneLabel(item.name, item.value)"
            :name="item.state + ''"
          >
          </el-tab-pane>
        </el-tabs>
        <!-- 待履约 -->
        <el-tabs
          v-if="allActiveName === '1'"
          type="card"
          v-model="activeName"
          @tab-click="handleTab"
        >
          <el-tab-pane
            v-for="(item, index) of c_enterpriseTabsList"
            :label="`${item.label}(${item.number})`"
            :name="item.name"
            :key="index"
          >
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>

    <div class="whole_contract_from">
      <el-form ref="from_params" :model="params">
        <QS-search maxLine="1">
          <el-form-item label="子订单ID" prop="id">
            <el-input
              v-number:integer="18"
              v-model="params.id"
              placeholder="请输入子订单ID"
              clearable
            />
          </el-form-item>
          <el-form-item label="客户名称" prop="customerId">
            <el-select
              v-model="params.customerId"
              filterable
              clearable
              remote
              :remote-method="getCustomerList"
              placeholder="请输入客户名称搜索"
            >
              <el-option
                v-for="item in carProviderList"
                :key="item.id"
                :label="item.customerName"
                :value="item.id"
              >
                <CustomerNameOptionItem :data="item" />
              </el-option>
            </el-select>
          </el-form-item>
          <CarBrandSeriesModel
            v-model="brandSeriesModel"
            ref="carBrandSeriesModelRef"
            :showModel="true"
            :filterScene="CAR_MODEL_FILTER_SCENE.IN_STOCK"></CarBrandSeriesModel>
          <el-form-item label="运营城市" prop="adcode">
            <el-select
              v-model="params.adcode"
              clearable
              filterable
              reserveKeyword
              defaultFirstOption
            >
              <el-option
                v-for="item in allCities"
                :label="item.city"
                :value="item.adcode"
                :key="item.adcode"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="车源服务商" prop="providerId">
            <el-select
              clearable
              placeholder="请选择车源服务商"
              v-model="params.providerId"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in serviceList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="车牌号" prop="carId">
            <el-select
              v-model="params.carId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入"
              clearable
              :default-first-option="true"
              :remote-method="
                (query) => {
                  gerCarNoList(query)
                }
              "
              :loading="oLoading.fuzzySearch"
            >
              <el-option
                v-for="item in carList"
                :key="item.id"
                :label="item.plateNo"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!--  -->
          <el-form-item label="关联订单原因" prop="relatedType">
            <el-select
              v-model="params.relatedType"
              placeholder="请选择关联订单原因"
              clearable
            >
              <el-option
                v-for="item in this.dictParseList(
                  selectOptionDict.rderRelatedReason,
                  true
                )"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业租赁订单ID" prop="entRentOrderId">
            <el-input
              v-number:integer="18"
              v-model="params.entRentOrderId"
              placeholder="请输入租赁订单ID"
              clearable
            />
          </el-form-item>
          <!--  -->
          <el-form-item label="子订单创建时间" prop="startTime">
            <el-date-picker
              v-model="params.startTime"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="开始日期"
              range-separator="至"
              end-placeholder="结束日期"
              prefix-icon="el-icon-date"
              clearable
            />
          </el-form-item>
          <el-form-item label="发车验车时间" prop="TheCarExTime">
            <el-date-picker
              v-model="params.TheCarExTime"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="开始日期"
              range-separator="至"
              end-placeholder="结束日期"
              prefix-icon="el-icon-date"
              clearable
            />
          </el-form-item>
          <el-form-item label="计租结束日" prop="rentFinIsh">
            <el-date-picker
              v-model="params.rentFinIsh"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="开始日期"
              range-separator="至"
              end-placeholder="结束日期"
              prefix-icon="el-icon-date"
              clearable
            />
          </el-form-item>
          <el-form-item label="免租结束日" prop="presentEntTime">
            <el-date-picker
              v-model="params.presentEntTime"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="开始日期"
              range-separator="至"
              end-placeholder="结束日期"
              prefix-icon="el-icon-date"
              clearable
            />
          </el-form-item>
          <el-form-item label="租赁方案名称" prop="planId">
            <el-select
              v-model="params.planId"
              clearable
              filterable
              placeholder="请选择租赁方案"
            >
              <el-option
                v-for="item in planList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="所属部门" prop="deptIdList">
            <DeptSelect
              ref="deptSelectRef"
              v-model="params.deptIdList"
              prop="deptIdList"
              :multiple="true"
              :isAll="false"
            />
          </el-form-item>

          <!-- 按钮区域-->
          <template slot="moreBtn">
            <el-form-item>
              <el-button
                type="primary"
                size="small"
                class="whole_contract_btn"
                @click="getsearch"
                :loading="BLMloading"
              >
                查询
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                size="small"
                class="whole_contract_btn"
                @click="getreset"
              >
                重置
              </el-button>
            </el-form-item>
            <el-form-item v-if="judgePermission('workbench_ent_rent_order_sub_export')">
              <PublicExport
                exportTitle="企业租赁子订单导出"
                exportTemplate="LeaseOrderSub"
                :getSearchData="getCollect"
                templateCode="vehicle-workbench-ent-rent-sub-order"
                :getSearchCondition="getSearchCondition"
              />
            </el-form-item>
          </template>
        </QS-search>
      </el-form>
    </div>
    <el-button
      v-if="judgePermission('workbench_ent_rent_order_main_add')"
      type="primary"
      size="small"
      class="whole_contract_btn"
      @click="enterpriseSign"
    >
      企业签约提车
    </el-button>
    <div style="margin-top: 20px"></div>
    <!-- 开始 ---列表 -->
    <QSCommonTable
      :loading="BLMloading"
      :data="tableData"
      :columns="colList"
      :pagination="pagination"
      @change="handleTableChange"
    />
    <!-- 结束 ---列表 -->
    <!-- 一键换车 -->
    <OneKeyCarChange ref="oneKeyChangeCarRef" :isEnterprise="true" @updateList="updateList" />
  </div>
</template>
<script>
import selectOptionDict from '@/store/dict/selectOptionDict'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import { searchByCustomerName } from '@/api/domain/customers'
import {
  stockLogFindLastOne,
  FuzzySearch,
  getCarProvider,
  getLeasingSchemeConfigListAll,
} from '@/api/domain/cars'
import { PurchaseAndSeven, SureGiveup, TabListSeven } from '@/api/domain/orders'
import { checkBeforeChangeCar } from '@/api/domain/finance.js'

import { mapGetters } from 'vuex'
import { debounce } from '@/utils'
import { operateMaxShowLength } from '@/store/dict/config'
import { generateExportCondition } from '@/utils/exportUtils.js'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

import OneKeyCarChange from '@/pages/orders/personalOrder/components/oneKeyCarChange'

import { ONE_KEY_CHANGE_STATUS } from '@/store/dict/rentPlanDict.js'
import { ORDER_STATE } from '@/store/dict/order.js'


export default {
  name: 'childOrder',
  components: {
    CustomerNameOptionItem,
    OneKeyCarChange,
  },
  props: ['queryAllActiveName', 'plateNo'],
  data() {
    return {
      activeName: '1',
      selectOptionDict,
      // 企业租赁订单tabs
      c_enterpriseTabsList: [
        {
          label: '全部',
          number: 0,
          name: '1',
          key: 'toProcessOrderNum',
        },
        {
          label: '订单待支付',
          number: 0,
          name: '13',
          key: 'toPaymentOrderNum',
        },
        {
          label: '发车待验车',
          number: 0,
          name: '12',
          key: 'confirmedOrderNum',
        },
      ],
      // tab标签数据
      allTabList: [
        { value: '', key: 'allOrderNum', state: 0, name: '全部' },
        { value: '', key: 'toProcessOrderNum', state: 1, name: '待履约' },
        { value: '', key: 'inProcessOrderNum', state: 2, name: '履约中' },
        { value: '', key: 'inAccountOrderNum', state: 3, name: '退车核算' },
        { value: '', key: 'closedOrderNum', state: 4, name: '已关闭' },
      ],
      allActiveName: '0',
      accountingTabList: [
        { value: '', key: 'inAccountOrderNum', state: 3, name: '全部' },
        { value: '', key: 'toInStockOrderNum', state: 31, name: '退车待验车' },
        { value: '', key: 'toAccountOrderNum', state: 32, name: '订单待核算' },
      ],
      accountingActiveName: '3',
      colList: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '子订单ID',
            width: '120',
          },
          render: ({ row }) => {
            return (
              <div>
                <span
                  class="a-hover-link"
                  on-click={() => this.toOrderDetailPage({ id: row.id })}
                >
                  {row.id}
                </span>
              </div>
            )
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: '100',
          },
        },
        {
          name: 'brandName',
          columnProps: {
            prop: 'brandName',
            label: '品牌',
          },
        },
        {
          name: 'seriesName',
          columnProps: {
            prop: 'seriesName',
            label: '车系',
          },
        },
        {
          name: 'modelName',
          columnProps: {
            prop: 'modelName',
            label: '车型',
            width: 160,
          },
        },
        {
          name: 'city',
          columnProps: {
            prop: 'city',
            label: '运营城市',
          },
        },
        {
          name: 'providerName',
          columnProps: {
            prop: 'providerName',
            label: '车源服务商',
            width: 100,
          },
        },
        {
          name: 'customerName',
          columnProps: {
            prop: 'customerName',
            label: '客户名称',
            width: 110,
          },
        },
        {
          name: 'planName',
          columnProps: {
            prop: 'planName',
            label: '租赁方案名称',
            width: 130,
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '子订单创建时间',
            width: '160',
          },
        },
        {
          name: 'outStockTime',
          columnProps: {
            prop: 'outStockTime',
            label: '发车验车时间',
            width: '160',
          },
        },
        {
          name: 'startDate',
          columnProps: {
            prop: 'startDate',
            label: '计租开始日',
            width: '120',
          },
        },
        {
          name: 'endDate',
          columnProps: {
            prop: 'endDate',
            label: '计租结束日',
            width: '120',
          },
        },
        {
          name: 'presentEntDate',
          columnProps: {
            prop: 'presentEntDate',
            label: '免租结束日',
            width: '120',
          },
        },
        {
          name: 'rentAmount',
          columnProps: {
            prop: 'rentAmount',
            label: '每期租金',
            width: '110',
          },
        },
        {
          name: 'deposit',
          columnProps: {
            label: '总押金/已收',
            width: '120',
            align: 'left',
            formatter: (row) =>
              `${row.deposit === null ? '0.00' : row.deposit}/${
                row.receivedDeposit
              }`,
          },
        },
        {
          name: 'state',
          columnProps: {
            label: '子订单状态',
            formatter: (row) => this.stateList2[row.state],
            width: '120',
          },
        },
        {
          name: 'entRentOrderId',
          columnProps: {
            label: '企业租赁订单ID',
            width: '120',
          },
          render: ({ row }) => {
            return (
              <span>{row.entRentOrderId || '--'}</span>
            )
          },
        },
        {
          name: 'relatedType',
          columnProps: {
            label: '关联原因',
            width: '110',
            formatter: (row) =>
              selectOptionDict.rderRelatedReason[row.relatedType],
          },
        },
        {
          name: 'createUser',
          columnProps: {
            label: '订单创建人',
            prop: 'createUser',
            width: '110',
          },
        },
        {
          name: 'deptName',
          columnProps: {
            prop: 'deptName',
            label: '所属部门',
            width: 150,
          },
          showEllipsisTooltip: true,
          limitEllipsisLine: 1,
        },
      ],
      // 出入库弹窗相关数据
      outInBank: {
        type: '',
      },
      // 客户列表
      carProviderList: [],
      BLMloading: false,
      oLoading: {
        fuzzySearch: false,
      },
      carList: [],
      stateList2: {
        0: '订单待确认',
        1000: '订单待支付',
        1500: '发车待验车',
        2500: '履约中',
        3500: '退车待验车',
        4500: '订单待核算',
        5500: '已关闭',
      },
      // from表单内容
      params: {
        tabNo: 0, // 订单状态 默认全部
        bizType: 20, // 常量
        id: '', // 企业租赁订单ID
        customerId: '', // 客户
        startTime: [], // 开始时间
        endTime: '', // 结束时间
        deptIdList: [], // 所属部门
        carId: '', // 车牌号
        entRentOrderId: '', // 企业租赁订单ID
        modelId: '', // 车型
        providerId: '', // 车源服务商
        TheCarExTime: [], // 发车验车时间
        presentEntTime: [], // 免租结束日
        rentFinIsh: [], // 计租结束日
        relatedType: '', // 关联原因
        planId: '',
        adcode: '', // 运营城市
      },
      brandSeriesModel: {},
      // 表格总数据
      total: 0,
      // 表格请求的总数据
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      serviceList: [], // 车源服务商列表
      planList: [], // 租赁方案list
      // 客户列表
      customerConditionList: [],
      // 车牌号列表
      carIdConditionList: [],
      CAR_MODEL_FILTER_SCENE,
    }
  },
  watch: {
    'params.customerId': {
      handler() {
        this.customerConditionList = this.carProviderList
      },
    },
    'params.carId': {
      handler() {
        this.carIdConditionList = this.carList
      },
    },
    brandSeriesModel: {
      handler(val) {
        const { brandId, seriesId, modelId } = val
        this.params.brandId = brandId
        this.params.seriesId = seriesId
        this.params.modelId = modelId
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['allCities']),
    // 操作栏显示条件-公司视角下且所有权限有一个已下放
    operateNodeObj() {
      return {
        name: 'operate',
        columnProps: {
          label: '操作',
          fixed: 'right',
          width: 240,
        },
        maxShowLength: operateMaxShowLength,
        type: 'operate',
        // 待履约
        //   --订单待确认 0
        //  订单待支付 1000
        //   --发车待验车 1500
        //   --履约中 2500
        // 退车核算
        //   --退车待验车 3500
        //   --订单待核算 4500
        //   --已关闭 5500
        getOperateList: ({ row }) => {
          const btnArr = []
          if (
            this.judgePermission('workbench_ent_rent_order_main_add_car') &&
            [2500].includes(row.state)
          ) {
            btnArr.push({
              name: 'addRentOrder',
              label: '订单续约',
              action: () => this.handlerRecallClick(row),
            })
          }
          this.judgePermission('workbench_ent_rent_order_sub_finance_detail') &&
            [1000].includes(row.state) &&
            btnArr.push({
              name: 'toReceiptandpayment_name',
              label: '订单支付',
              action: () => this.toReceiptandpayment(row),
            })
          this.judgePermission('workbench_ent_rent_order_sub_to_out_stock') &&
            [1500].includes(row.state) &&
            btnArr.push({
              name: 'carOperationOutInAdd_name',
              label: '发车验车',
              action: () => this.outInBankPop(row.carId, 1, row),
            })
          this.judgePermission('workbench_ent_rent_order_sub_to_in_stock') &&
            row.state === 3500 &&
            btnArr.push({
              name: 'carOperationOuts_name',
              label: '退车验车',
              action: () => {
                // "订单作废"和"发车失败"走原有逻辑，其余跳转到客户还车页面
                if (row.closeType === 0 || row.closeType === 1) {
                  this.returnCar(row.carId, 2, row)
                } else {
                  this.toReturnCarPage(row)
                }
              },
            })
          //
          this.judgePermission('workbench_ent_rent_order_sub_return_vehicle') &&
            [0, 1000, 1500, 2500].includes(row.state) &&
            btnArr.push({
              name: 'closeRentOrders_name',
              label: '退车解约',
              action: () => {
                // "待履约"状态退车走原有逻辑，其余跳转到客户还车页面
                if ([0, 1000, 1500].includes(row.state)) {
                  this.closeTheCar(row)
                } else {
                  this.toReturnCarPage(row)
                }
              },
            })
          this.judgePermission('workbench_ent_rent_order_sub_waive') &&
            row.state === 3500 &&
            btnArr.push({
              name: 'cancelReturnCars_name',
              label: '放弃退车',
              action: () => this.giveupTheCar(row),
            })
          this.judgePermission('workbench_ent_rent_order_sub_settlement') &&
            row.state === 4500 &&
            btnArr.push({
              name: 'confirmSettlements_name',
              label: row.settlementState === 4 ? '重新核算' : '订单核算',
              action: () => {
                // "订单作废"和"发车失败"走原有逻辑，其余跳转到客户还车页面
                if (row.closeType === 0 || row.closeType === 1) {
                  const { id } = row
                  const queryObj = { orderId: id }
                  const queryStr = encodeURIComponent(JSON.stringify(queryObj))
                  this.$router.push(
                    `/returnLease/returnCar/enterpriseAdd?query=${queryStr}`,
                  )
                } else {
                  this.toReturnCarPage(row)
                }
              },
            })

          if (row.state === ORDER_STATE.RENTING
                          && [ONE_KEY_CHANGE_STATUS.INITIAL,
                            ONE_KEY_CHANGE_STATUS.APPROVAL].includes(row.changeCarState)
                          && this.judgePermission('rentIngOneKeyChangeCarForEnterprise')) {
            btnArr.push({
              label: '一键换车',
              action: () => this.showOneKeyChangeCar(row, 'selectNewCar'),
            })
          }

          if (row.state === ORDER_STATE.RENTING
                && row.changeCarState === ONE_KEY_CHANGE_STATUS.CHECKING
                && this.judgePermission('rentIngOneKeyChangeCarForEnterprise')
          ) {
            btnArr.push({
              label: '换车验车',
              action: () => this.showOneKeyChangeCar(row, 'checkAndReplaceCar'),
            })
          }
          return btnArr
        },
      }
    },
    pagination() {
      return {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        total: this.total,
      }
    },
  },
  async mounted() {
    this.getRouteQuery()
    this.getPlanList() // 获取租赁方案list
    this.getSummary()
    this.getCarProvider()
    this.colList.push(this.operateNodeObj)
    if (this.plateNo) {
      this.BLMloading = true
      await this.gerCarNoList(this.plateNo)
      const filterItem = this.carList.find((item) => item.plateNo === this.plateNo)
      this.params.carId = filterItem.id
    }
    this.getTableData()
  },
  methods: {
    async getPlanList() {
      // orderType(类型) - 1:个人; 2:企业;
      const res = await getLeasingSchemeConfigListAll({ orderType: 2 })
      const data = res?.data || []
      const customerOption = {
        name: '自定义',
        id: 0,
      }
      data.unshift(customerOption)
      this.planList = data
      const planId = this.$route?.query?.planId
      if (planId) {
        this.params.planId = Number(planId)
        this.getTableData()
      }
    },
    // 退车
    returnCar(id, type, row) {
      this.outInBank.type = type
      stockLogFindLastOne({
        carId: id,
        type,
        orderId: row.id,
        sourceType: 1,
        sourceId: row.id,
      }).then((res) => {
        const { data } = res
        this.$router.push({
          path: '/vehicle/outInStorage/edit',
          query: {
            carId: id,
            type,
            stockId: data.id,
            from: 'lease', // 为了让出入库页面back
          },
        })
      })
    },
    // 企业签约提车
    enterpriseSign() {
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/enterSiginProcess',
        query: {
          stepActive: 0,
        },
      })
    },
    getRouteQuery() {
      const { attributeId } = this.$route.query
      // attributeId 待办任务跳转
      this.params.id = Number(attributeId) || ''

      // 数据报表跳转参数
      if (this.queryAllActiveName) {
        this.allActiveName = this.queryAllActiveName
        this.params.tabNo = Number(this.queryAllActiveName)
      }
    },
    // tab数据----请求数据
    async getSummary() {
      try {
        const { code, data } = await TabListSeven({
          bizType: 20,
        })
        if (code === 1) {
          Object.keys(data).forEach((item) => {
            this.allTabList.forEach((arr) => {
              if (arr.key === item) {
                arr.value = data[item]
                return false
              }
            })
            // 待履约下
            this.c_enterpriseTabsList.forEach((arr) => {
              if (arr.key === item) {
                arr.number = data[item]
                return false
              }
            })
            // 退车核算
            this.accountingTabList.forEach((arr) => {
              if (arr.key === item) {
                arr.value = data[item]
                return false
              }
            })
          })
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    returnPaneLabel(val, content) {
      if (content) {
        return `${val} ( ${content} ) `
      } else {
        return `${val} ( 0 ) `
      }
    },
    async showOneKeyChangeCar(row, type) {
      if (type === 'selectNewCar') {
        const { code } = await checkBeforeChangeCar({
          orderId: row.id,
        })
        if (code === 1) {
          this.$refs.oneKeyChangeCarRef.open(row, type)
        }
      } else {
        this.$refs.oneKeyChangeCarRef.open(row, type)
      }
    },
    updateList() {
      this.getTableData()
    },
    handleTab(e) {
      this.params.tabNo = Number(e.name)
      this.goReset()
      this.goSearch()
    },
    // 订单状态清空时，赋值0，表示全部，避免入参报错
    // eslint-disable-next-line vue/no-unused-properties
    clearChange() {
      this.params.tabNo = 0
    },
    handleTableChange({ pagination }) {
      this.pageSize = pagination.pageSize
      this.pageNum = pagination.pageNum
      this.getTableData()
    },
    // 模糊搜索获取车牌号
    async gerCarNoList(query) {
      query = query.trim()
      // 开启远程搜索
      if (query.length >= 4) {
        this.oLoading.fuzzySearch = true
        try {
          const { code, data } = await FuzzySearch({
            plateNo: query,
            state: 1,
          })
          if (code === 1) {
            this.carList = data
          }
          // 关闭远程搜索
          this.oLoading.fuzzySearch = false
        } catch (error) {
          this.oLoading.fuzzySearch = false
        }
      } else {
        this.carList = []
      }
    },
    goSearch() {
      this.getTableData()
    },
    // 重置--清空表单项
    goReset() {
      this.pageSize = 10
      this.pageNum = 1
      // 使表单内容重新赋值为空字符串
      this.$refs.from_params.resetFields()
    },
    // 点击id新开浏览器跳转详情页
    // eslint-disable-next-line vue/no-unused-properties
    handleOrderIdClick(id) {
      const routeUrl = this.$router.resolve({
        path: '/workbench/entOrder/detail/child',
      })
      this.$router.push({
        path: routeUrl.href,
        query: {
          id,
        },
      })
    },
    async getCustomerList(customerName) {
      if (!customerName && customerName.length < 1) return
      const { code, data = [] } = await searchByCustomerName({
        customerState: 1,
        customerType: 2,
        customerName,
      })
      if (code === 1) {
        this.carProviderList = data
      }
    },
    // 分页器的事件
    // eslint-disable-next-line vue/no-unused-properties
    async pageEvent(pageSize, pageNum) {
      this.BLMloading = true
      this.pageSize = pageSize
      this.pageNum = pageNum
      this.getTableData()
    },
    // 收集上传的数据
    getCollect() {
      const p = {
        ...this.params,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        createTimeStart: this.params.startTime ? this.params.startTime[0] : '',
        createTimeEnd: this.params.startTime ? this.params.startTime[1] : '',
        outStockTimeStart:
          (this.params.TheCarExTime && this.params.TheCarExTime[0]) || '',
        outStockTimeEnd:
          (this.params.TheCarExTime && this.params.TheCarExTime[1]) || '',
        presentEntTimeStart:
          (this.params.presentEntTime && this.params.presentEntTime[0]) || '',
        presentEntTimeEnd:
          (this.params.presentEntTime && this.params.presentEntTime[1]) || '',
        rentEndTimeStart:
          (this.params.rentFinIsh && this.params.rentFinIsh[0]) || '',
        rentEndTimeEnd:
          (this.params.rentFinIsh && this.params.rentFinIsh[1]) || '',
      }
      return p
    },
    // 处理按钮显示内容
    // eslint-disable-next-line vue/no-unused-properties
    getMultiple(state) {
      switch (state) {
        case 1:
          // 待确认
          return '订单确认'
        case 2:
          // 订单状态「进行中」
          return '订单变更'
        case 3:
          // 订单状态「已完成」
          return '订单变更'
        default:
          return ''
      }
    },
    // 搜索按钮
    getsearch: debounce(async function () {
      this.pageSize = 10
      this.pageNum = 1
      this.getTableData()
    }, 500),
    // 重置--清空表单项
    getreset() {
      this.pageSize = 10
      this.pageNum = 1
      // 使表单内容重新赋值为空字符串
      this.$refs.from_params.resetFields()
      this.$refs.carBrandSeriesModelRef.reset()
      this.brandSeriesModel = {}
      this.$nextTick(() => {
        this.getTableData()
      })
    },
    // 新增采购单按钮点击事件
    // eslint-disable-next-line vue/no-unused-properties
    addSigning() {
      const routeUrl = this.$router.resolve({
        name: 'lease_order_add',
      })
      window.open(routeUrl.href, '_blank')
    },
    // 操作列----订单确认/部分退车按钮
    // eslint-disable-next-line vue/no-unused-properties
    getOperation(item) {
      let routeUrl = ''
      switch (item.state) {
        case 1:
          // 订单确认按钮
          routeUrl = this.$router.resolve({
            name: 'lease_order_confirm',
            query: { id: item.id },
          })
          break
        case 2:
          // 2进行中 部分退车按钮
          routeUrl = this.$router.resolve({
            name: 'lease_order_return_record_add',
            query: { id: item.id },
          })
          break
        case 3:
          // 3已完成 部分退车按钮
          routeUrl = this.$router.resolve({
            name: 'lease_order_return_record_add',
            query: { id: item.id },
          })
          break
        default:
          break
      }
      window.open(routeUrl.href, '_blank')
    },
    // 请求数据table
    async getTableData() {
      this.BLMloading = true
      try {
        const { code, data } = await PurchaseAndSeven(this.getCollect())
        if (code === 1) {
          this.tableData = data.items
          this.total = data.totalNum
        }
        this.BLMloading = false
      } catch (error) {
        console.log(error)
      }
      this.BLMloading = false
    },
    // 去客户还车页面
    toReturnCarPage(row) {
      const queryObj = { orderId: row.id }
      const queryStr = JSON.stringify(queryObj)
      this.$router.push({
        name: 'return_lease_ent_start',
        query: {
          query: queryStr,
          scene: this.$route.query.scene || '',
        },
      })
    },
    // 页面跳转
    toOrderDetailPage(params) {
      const path = '/workbench/entOrder/detail/child'
      const query = {
        ...params,
        scene: this.$route.query.scene || '',
      }
      this.$router.push({
        path,
        query,
      })
    },
    // 去订单确认页面
    // eslint-disable-next-line vue/no-unused-properties
    toOrderConfirmPage(row) {
      const query = { id: row.id, confirm: 1 }
      this.toOrderDetailPage(query)
    },
    // 点击跳转订单续约
    handlerRecallClick(rowData) {
      this.$router.push({
        path: '/underLease/orderRenewal/enterpriseSubAdd',
        query: {
          stepActive: 1,
          orderId: rowData.id,
          orderType: 'enterpriseSub',
          plateNo: rowData.plateNo,
          carId: rowData.carId,
          customerId: rowData.customerId,
          customerName: rowData.customerName,
        },
      })
    },
    // 查看财务进度 =》收付款信息
    toReceiptandpayment(row) {
      if (row.relatedType) {
        const query = { id: row.id, type: 1 }
        this.toOrderDetailPage(query)
        return
      }
      // 新
      const query = { orderId: row.id, stepActive: 3 }
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/enterSiginProcess',
        query,
      })
    },
    // 点击订单关闭
    closeTheCar(row) {
      const query = { id: row.id, state: row.state, type: 5, returnInfoType: 2 }
      this.toOrderDetailPage(query)
    },
    // 放弃退车
    giveupTheCar({ id }) {
      this.$confirm('确定要放弃退车吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(async () => {
          const { code } = await SureGiveup({
            orderId: id,
          })
          if (code === 1) {
            this.$message({
              message: '放弃退车成功',
              type: 'success',
            })
            this.getTableData()
          }
        })
        .catch(() => null)
    },
    // 获取出入库记录
    outInBankPop(id, type, row) {
      if (!row.relatedType) {
        // 新
        const query = { orderId: row.id, stepActive: 4 }
        this.$router.push({
          path: '/car_to_lease/forRentSignContract/enterSiginProcess',
          query,
        })
        return
      }
      this.returnCar(id, type, row)
    },
    async getCarProvider() {
      // 服务类型(枚举 0车源方 1维修厂 2保险公司 3车源方)
      const { code, data } = await getCarProvider({ serviceType: 0 })
      if (code !== 1) return
      this.serviceList = data?.items || []
    },
    getSearchCondition() {
      const formConfig = [{
        el: 'input',
        itemConfig: {
          label: '子订单ID',
          prop: 'id',
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '客户名称',
          prop: 'customerId',
        },
        elConfig: {
          options: {
            list: this.customerConditionList,
            value: 'id',
            label: 'customerName',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '运营城市',
          prop: 'adcode',
        },
        elConfig: {
          options: {
            list: this.allCities,
            label: 'city',
            value: 'adcode',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '车源服务商',
          prop: 'providerId',
        },
        elConfig: {
          options: {
            list: this.serviceList,
            label: 'name',
            value: 'id',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '车牌号',
          prop: 'carId',
        },
        elConfig: {
          options: {
            list: this.carIdConditionList,
            label: 'plateNo',
            value: 'id',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '关联订单原因',
          prop: 'relatedType',
        },
        elConfig: {
          options: {
            list: this.dictParseList(
              selectOptionDict.rderRelatedReason,
              true,
            ),
            label: 'label',
            value: 'value',
          },
        },
      }, {
        el: 'input',
        itemConfig: {
          label: '企业租赁订单ID',
          prop: 'entRentOrderId',
        },
      }, {
        el: 'date-picker',
        itemConfig: {
          label: '子订单创建时间',
          prop: 'startTime',
        },
      }, {
        el: 'date-picker',
        itemConfig: {
          label: '发车验车时间',
          prop: 'TheCarExTime',
        },
      }, {
        el: 'date-picker',
        itemConfig: {
          label: '计租结束日',
          prop: 'rentFinIsh',
        },
      }, {
        el: 'date-picker',
        itemConfig: {
          label: '免租结束日',
          prop: 'presentEntTime',
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '租赁方案名称',
          prop: 'planId',
        },
        elConfig: {
          options: {
            list: this.planList,
            value: 'id',
            label: 'name',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '所属部门',
          prop: 'deptIdList',
        },
        elConfig: {
          options: {
            list: this.$refs.deptSelectRef.flatOptions(),
            value: 'id',
            label: 'name',
          },
        },
      }]
      const condition = formConfig.map((item) => {
        const { el, itemConfig: { label, prop: key } } = item
        const val = this.params[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      }).concat([{
        label: '订单类型',
        matchValue: '企业租赁子订单',
      }, {
        label: '订单状态',
        matchValue: this.allTabList.find((item) => String(item.state) === this.allActiveName)?.name,
      }])
      if (this.allActiveName === '3') {
        // 待履约（3）
        condition[condition.length - 1].matchValue += `-${this.accountingTabList.find((item) => String(item.state) === this.accountingActiveName)?.name}`
      } else if (this.allActiveName === '1') {
        // 退车核算（1）
        condition[condition.length - 1].matchValue += `-${this.c_enterpriseTabsList.find((item) => item.name === this.activeName)?.label}`
      }
      const labels = this.$refs.carBrandSeriesModelRef.getLabels()
      const { brandSeries, model } = labels
      condition.splice(2, 0, brandSeries, model)
      return condition
    },
  },
}
</script>
<style lang="scss" scoped>
.orderId {
  color: #2e7eff;
  cursor: pointer;
}
.leasecontract {
  ::v-deep .el-tabs__item {
    max-width: 140px;
    text-align: center;
  }
  .whole_contract_btn {
    &:nth-of-type(2) {
      color: #323233;
    }
  }
  .leasecontract_signing {
    margin: 16px 0;
  }
  .hand {
    user-select: none;
    span {
      cursor: pointer;
    }
  }
}
</style>
